/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron Expression Explainer`)
};

const es_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador de Expresiones Cron`)
};

const de_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron-Ausdruck-Erklärer`)
};

const nl_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron-expressieverklaarder`)
};

const fr_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explication d'expressions cron`)
};

const it_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiegatore di Espressioni Cron`)
};

const pt_br2_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador de Expressões Cron`)
};

const pt_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador de Expressões Cron`)
};

const ja_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron式エクスプレーナー`)
};

const zh_cr_nav_main = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron 表达式解释器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_nav_main = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_nav_main(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_nav_main", locale)
	if (locale === "en") return en_cr_nav_main(inputs)
	if (locale === "es") return es_cr_nav_main(inputs)
	if (locale === "de") return de_cr_nav_main(inputs)
	if (locale === "nl") return nl_cr_nav_main(inputs)
	if (locale === "fr") return fr_cr_nav_main(inputs)
	if (locale === "it") return it_cr_nav_main(inputs)
	if (locale === "pt-BR") return pt_br2_cr_nav_main(inputs)
	if (locale === "pt") return pt_cr_nav_main(inputs)
	if (locale === "ja") return ja_cr_nav_main(inputs)
	return zh_cr_nav_main(inputs)
};